import { ApiClientError, Domain } from '@raydiant/api-client-js';
import { keys } from '../queryClient';
import raydiant from '../clients/miraClient';
import useProtectedQuery from './useProtectedQuery';
import { UseQueryOptions } from 'react-query';

export default function useGetDomain(
  options: UseQueryOptions<Domain | null, ApiClientError> = {},
) {
  return useProtectedQuery<Domain | null, ApiClientError>(
    keys.domain(),
    () => raydiant.getDomain(),
    {
      enabled: true,
      ...options,
    },
  );
}
